// extracted by mini-css-extract-plugin
export default {"card":"gY-z","carouselContainer":"hY-z","carouselContent":"iY-z"};